"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
class NoGpsReadingWithIndexError extends Error {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", 'NoGpsReadingWithIndexError');
  }
}
exports.default = NoGpsReadingWithIndexError;